
export interface PaymentIntentRequest {
  orderId: number;
  invoiceNumber: string;
  amount: number;
  paymentMethod: string; // 'CARD' | 'CASH' | ...
  customerName?: string;
  customerEmail?: string;
}

export interface PaymentIntentResponse {
  redirectUrl: string;
  transactionId: string;
}

export interface Payment {
  id: number;
  transactionId: string;
  orderId: number;
  invoiceNumber?: string;
  amount: number;
  paymentMethod: string;
  status: string;
  cardLastFour?: string | null;
  cardBrand?: string | null;
  gatewayResponse?: string | null;
  gatewayTransactionId?: string | null;
  processedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  notes?: string | null;
  refundAmount?: number;
  refundReason?: string | null;
  refundedAt?: string | null;
  refundable?: boolean;
  remainingAmount?: number;
}
